var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`m-tooltip-container ${_vm.enabled ? 'show' : ''}`},[_c('div',{ref:"child",staticClass:"child"},[_vm._t("default")],2),(!_vm.pagination)?_c('div',{ref:"tooltip",staticClass:"m-tooltip",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }